<template>
<div class="panel">
  <div class="panel-content">
    <div class="panel-title">{{ $t('names.tools') }}</div>
    <div class="row">
      <div
        v-for="tool in tools"
        :key="tool"
        class="q-pa-xs col-4 text-center"
      >
        <tools-item
          :name="tool"
          :tool="$config.tools[tool]"
        />
      </div>
    </div>
  </div>
</div>
</template>

<script>
import ToolsItem from './ToolsItem.vue'

export default {
  components: {
    ToolsItem
  },
  computed: {
    tools () {
      return this.$config.layout.home.tools.filter(tool => {
        return !this.$config.tools[tool].supported || this.$config.tools[tool].supported.call(this, this.$config.tools[tool])
      })
    }
  }
}
</script>

<style>

</style>
